import red from "@material-ui/core/colors/red";
import indigo from "@material-ui/core/colors/indigo";
import deepPurple from "@material-ui/core/colors/deepPurple";
import pink from "@material-ui/core/colors/pink";
import yellow from "@material-ui/core/colors/yellow";
import teal from "@material-ui/core/colors/teal";
import grey from "@material-ui/core/colors/grey";

const parseColor = (color) => color.replace("#", "");

const colors = [red, pink, indigo, deepPurple, teal, yellow, grey];
const shades = [900, 700, 600, 500, 400, 300, 100];

export default [
  ...colors.flatMap((color) =>
    shades.map((shade) => {
      return {
        name: color[shade],
        value: parseColor(color[shade]),
        border: shade === 100,
      };
    })
  ),
];
